import React, { useState, useEffect } from "react";
import { supabase } from "../../supabaseClient";
import socerPlayerIcon from "../../Assets/Icons/soccer-player.png";
import LoaderBox from "./LoaderBox";

const HomeScorers = () => {
  const [scorers, setScorers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hideDataMode, setHideDataMode] = useState(false);

  useEffect(() => {
    const fetchTopScorers = async () => {
      setLoading(true);
      try {
        const { data: settings } = await supabase
          .from("site_settings")
          .select("hide_data_mode")
          .eq("id", 1)
          .single();
        if (settings) setHideDataMode(settings.hide_data_mode);
        const { data: matches, error } = await supabase
          .from("matches")
          .select("events");

        if (error) throw error;

        const scorerMap = {};

        if (matches) {
          matches.forEach((match) => {
            if (match.events && Array.isArray(match.events)) {
              match.events.forEach((event) => {
                // Brojimo samo regularne golove i penale
                if (event.type === "goal" || event.type === "penalty") {
                  const pName = event.player;
                  const tName = event.teamName || "Nepoznat tim";

                  if (!pName) return;

                  // Kreiramo jedinstveni ključ (Ime + Tim) da izbjegnemo miješanje igrača istog imena
                  const key = `${pName}-${tName}`;

                  if (!scorerMap[key]) {
                    scorerMap[key] = {
                      name: pName,
                      team: tName,
                      goals: 0,
                    };
                  }
                  scorerMap[key].goals += 1;
                }
              });
            }
          });
        }

        // Pretvaranje u niz i sortiranje od najviše prema najmanje golova
        const finalScorers = Object.values(scorerMap)
          .filter((player) => player.goals > 0)
          .sort((a, b) => b.goals - a.goals)
          .slice(0, 10);

        setScorers(finalScorers);
      } catch (err) {
        console.error("Greška pri dohvaćanju strijelaca:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTopScorers();
  }, []);

  if (loading) return <LoaderBox text="Učitavanje strijelaca..." />;

  if (hideDataMode) {
    return (
      <div className="scorers-container">
        <div className="scorers-header">
          <img src={socerPlayerIcon} alt="Strijelci icon" />
          <h3>Najbolji Strijelci</h3>
        </div>

        <div className="scorers-list">
          <div
            className="no-scorers-info"
            style={{ textAlign: "center", padding: "30px", color: "#888" }}
          >
            <p>Trenutno nema strijelaca za prikaz.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="scorers-container">
      <div className="scorers-header">
        <img src={socerPlayerIcon} alt="Strijelci icon" />
        <h3>Najbolji Strijelci</h3>
      </div>

      <div className="scorers-list">
        {scorers.length > 0 ? (
          scorers.map((player, index) => (
            <div key={`${player.name}-${index}`} className="scorer-item">
              <div className="rank-name">
                <span
                  className={`rank ${
                    index === 0
                      ? "gold"
                      : index === 1
                        ? "silver"
                        : index === 2
                          ? "bronze"
                          : ""
                  }`}
                >
                  {index + 1}.
                </span>
                <div className="player-info">
                  <span className="player-name">{player.name}</span>
                  <span className="team-name">{player.team}</span>
                </div>
              </div>

              <div className="goals-count">
                <span className="count">{player.goals}</span>
                <i className="fi fi-rs-football"></i>
              </div>
            </div>
          ))
        ) : (
          <div
            className="no-scorers-info"
            style={{ textAlign: "center", padding: "30px", color: "#888" }}
          >
            <p>Trenutno nema strijelaca za prikaz.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomeScorers;
